'use client';

import { c as _c } from "react/compiler-runtime";
import { motion, useInView } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image, { StaticImageData } from 'next/image';
import { useRef } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import ViverseButton from '@/components/ViverseButton';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import ImageCreatorProgram from '@/public/images/creator-grants/banner.png';
import ImagePartnerProgramDesktop from '@/public/images/partner/program-section-desktop.png';
import ImagePartnerProgramMobile from '@/public/images/partner/program-section-mobile.png';
function ProgramCard(t0) {
  const $ = _c(38);
  const {
    title,
    description,
    link,
    image,
    imageMobile,
    reverse
  } = t0;
  const t = useTranslations();
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isInView = useInView(ref, t1);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const currentImage = imageMobile && isMobile ? imageMobile : image;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      opacity: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isInView ? 1 : 0;
  let t4;
  if ($[2] !== t3) {
    t4 = {
      opacity: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = reverse ? "right-0 bg-[#73EAFF33]" : "left-0 bg-[#903BFF]";
  let t6;
  if ($[4] !== t5) {
    t6 = cn("1.5xl:flex absolute hidden h-[277px] w-[423px] blur-[424px]", t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <div className={t6} />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = reverse ? "1.5xl:flex-row-reverse" : "1.5xl:flex-row";
  let t9;
  if ($[8] !== t8) {
    t9 = cn("1.5xl:gap-12 1.5xl:p-12 1.5xl:h-[456px] flex w-full max-w-[1520px] flex-col items-center justify-center gap-6 rounded-3xl p-3 backdrop-blur-xl md:p-6", t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      background: "linear-gradient(360deg, rgba(42, 54, 73, 0.5) 0%, rgba(42, 54, 73, 0.3) 100%)"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== currentImage || $[12] !== title) {
    t11 = <div className="1.5xl:aspect-636/360 1.5xl:min-w-[636px] relative aspect-334/360 w-full overflow-hidden rounded-3xl md:aspect-640/360"><Image src={currentImage} alt={title} fill={true} sizes="(max-width: 767px) calc(100vw - 56px), (max-width: 1535px) calc(100vw - 80px), 636px" className="object-cover" /></div>;
    $[11] = currentImage;
    $[12] = title;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== title) {
    t12 = <h3 className="text-2xl font-bold md:text-[30px]">{title}</h3>;
    $[14] = title;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== description) {
    t13 = <p className="subheader-2 md:button text-vive-primary-30 font-medium md:text-2xl md:leading-8">{description}</p>;
    $[16] = description;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t) {
    t14 = t("creator-program.banner.cta");
    $[18] = t;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14) {
    t15 = <ViverseButton size="filter" className="1.5xl:px-6 1.5xl:py-3 1.5xl:text-[22px] min-h-12 py-3 text-[18px] whitespace-normal">{t14}</ViverseButton>;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== link || $[23] !== t15) {
    t16 = <Link className="w-fit" href={link}>{t15}</Link>;
    $[22] = link;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t12 || $[26] !== t13 || $[27] !== t16) {
    t17 = <div className="flex flex-col gap-4">{t12}{t13}{t16}</div>;
    $[25] = t12;
    $[26] = t13;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t11 || $[30] !== t17 || $[31] !== t9) {
    t18 = <div className={t9} style={t10}>{t11}{t17}</div>;
    $[29] = t11;
    $[30] = t17;
    $[31] = t9;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="1.5xl:flex absolute top-0 right-[-200px] hidden h-[387px] w-[513px] bg-[#73EAFF33] blur-[254px]" />;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t18 || $[35] !== t4 || $[36] !== t7) {
    t20 = <motion.div ref={ref} className="1.5xl:px-20 1.5xl:py-10 relative px-4" initial={t2} animate={t4}>{t7}{t18}{t19}</motion.div>;
    $[34] = t18;
    $[35] = t4;
    $[36] = t7;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  return t20;
}
export default function ApplyProgramSection() {
  const $ = _c(22);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t.rich("apply-program.title", {
      highlight: _temp
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="md:header-2 header-3 1.5xl:mb-10 inline w-full px-4 text-center"><span>{t0}</span></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("partner.apply-form.title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("partner.apply-form.description");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <ProgramCard title={t2} description={t3} link="/partner" image={ImagePartnerProgramDesktop} reverse={true} imageMobile={ImagePartnerProgramMobile} />;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t) {
    t5 = t("creator-intro.apply-form.title");
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("creator-intro.apply-form.description");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <ProgramCard title={t5} description={t6} link="/creator-grants" image={ImageCreatorProgram} />;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t4 || $[20] !== t7) {
    t8 = <motion.div className="1.5xl:gap-0 flex flex-col items-center gap-12 md:gap-20">{t1}{t4}{t7}</motion.div>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp(chunks) {
  return <span className="text-primary">{chunks}</span>;
}